import React from 'react';
import classNames from 'classnames';

import { US_STATES } from '../../config/usStates';
import { useConfiguration } from '../../context/configurationContext';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import getCountryCodes from '../../translations/countryCodes';

import css from './ShippingDestinationSelect.module.css';

/**
 * Soft country → US-state destination picker. Label-above, like OrderPanel delivery.
 *
 * @component
 * @param {Object} props
 * @param {string} props.idPrefix
 * @param {{ country?: string, state?: string }|null} [props.destination]
 * @param {Function} props.onChange
 * @param {string} [props.className]
 * @returns {JSX.Element}
 */
const ShippingDestinationSelect = props => {
  const { idPrefix, destination, onChange, className } = props;
  const intl = useIntl();
  const config = useConfiguration();
  const locale = config?.localization?.locale || 'en';
  const countryCodes = getCountryCodes(locale);
  const country = destination?.country || '';
  const state = destination?.state || '';
  const showState = country === 'US';

  const countryId = `${idPrefix}.country`;
  const stateId = `${idPrefix}.state`;

  return (
    <div className={classNames(css.root, className)}>
      <label className={css.label} htmlFor={countryId}>
        <FormattedMessage id="ShippingDestination.countryLabel" />
      </label>
      <select
        id={countryId}
        className={css.select}
        value={country}
        onChange={event => {
          const nextCountry = event.target.value || null;
          onChange({ country: nextCountry, state: nextCountry === 'US' ? state : null });
        }}
      >
        <option value="">
          {intl.formatMessage({ id: 'ShippingDestination.countryPlaceholder' })}
        </option>
        {countryCodes.map(entry => (
          <option key={entry.code} value={entry.code}>
            {entry.name}
          </option>
        ))}
      </select>
      {showState ? (
        <>
          <label className={css.label} htmlFor={stateId}>
            <FormattedMessage id="ShippingDestination.stateLabel" />
          </label>
          <select
            id={stateId}
            className={css.select}
            value={state}
            onChange={event => {
              onChange({ country, state: event.target.value || null });
            }}
          >
            <option value="">
              {intl.formatMessage({ id: 'ShippingDestination.statePlaceholder' })}
            </option>
            {US_STATES.map(entry => (
              <option key={entry.code} value={entry.code}>
                {entry.name}
              </option>
            ))}
          </select>
        </>
      ) : null}
    </div>
  );
};

export default ShippingDestinationSelect;
